/**
 * Session app-data for salon flow (salon admin backend via nginx on analyze.nyafaz.com).
 * Production: https://analyze.nyafaz.com/salon/session/app-data/...
 * Dev: proxied by setupProxy.js to localhost:5003
 */
import { SALON_APP_BASE } from './salonApp';

export const SESSION_APP_DATA_BASE = '/salon/session/app-data';
/** After login, hub is the shared app picker; landing remains the salon skin entry. */
export function getSessionLandingPath(token) {
  const t = typeof token === 'string' ? token.trim() : '';
  if (!t) return `${SALON_APP_BASE}/login`;
  return `${SALON_APP_BASE}/landing`;
}
